import { useDispatch, useSelector } from 'react-redux';
import { IState, actions } from '../../Store/reducer';
import creatures from '../../Services/creatures';
import { PlainBox } from '../PlainBox';
import './creature.scss';

type CreatureProps = {
    creature: { id: string, currentHp: number };
    deleteCreature: () => void;
    duplicateCreature: () => void;
    index: number;
};

function Creature(props: CreatureProps) {
    const dispatch = useDispatch();
    const { numberOfPlayers } = useSelector((state: IState) => state.master);

    const creatureInfo = creatures[props.creature.id];
    const opacity = (80 * props.creature.currentHp / creatureInfo.hp[numberOfPlayers] / 100) + .2;

    function updateHp(value: number) {
        dispatch({
            type: actions.master.SET_CREATURE_HP,
            payload: { index: props.index, hp: Math.max(0, props.creature.currentHp + value) }
        });
    }

    return (
        <div className="creature-box" style={{ backgroundImage: 'url(/image/character-box.png)' }}>
            <div className="creature-box-close" onClick={() => props.deleteCreature()}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42.14 45"><g fill="none"><path fill="#ec672a" d="m41.14,6.22l-15.31,16.35,14.78,15.79c1.25,1.34,1.25,3.5,0,4.83-1.25,1.34-3.28,1.34-4.53,0l-14.78-15.79-15.47,16.52c-1.33,1.42-3.49,1.42-4.83,0-1.33-1.42-1.33-3.73,0-5.16l15.47-16.52L1.68,6.46C.43,5.13.43,2.96,1.68,1.63,2.93.29,4.96.29,6.21,1.63l14.79,15.79L36.31,1.07c1.33-1.42,3.5-1.42,4.83,0,1.33,1.42,1.33,3.73,0,5.16"/></g></svg>
            </div>
            <div className="creature-name">
                <PlainBox fill="#cb9e4b" />
                <span>{creatureInfo.name}</span>
            </div>
            <div className="creature-details">
                <img className="creature-image" src={creatureInfo.image} alt={'Image ' + creatureInfo.name} />
                <div className="hp-button noselect" onClick={() => updateHp(-1)}>-</div>
                <div className="hp-value">
                    <svg style={{ opacity: opacity }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 127.78 100"><g><path fill="#513322" d="m63.89,16.26C28.75-23.54-21.23,17.48,9.67,56.37c11.38,14.32,26.98,23.43,53.96,43.44l.12.09s.09.06.13.1c27.15-20.14,42.8-29.26,54.22-43.63,30.91-38.89-19.08-79.91-54.22-40.12Zm45.14,22.48c2.56-4.83.09-10.88-4.54-12.92,0,0,2.91-4.11,2.91-4.11,4.91,4.23,6.16,12.42,1.63,17.03Z" /></g></svg>
                    <span>{props.creature.currentHp} / {creatureInfo.hp[numberOfPlayers]}</span>
                </div>
                <div className="hp-button noselect" onClick={() => updateHp(+1)}>+</div>
            </div>
        </div>
    );
}

export default Creature;